import type { RouteRecordRaw } from 'vue-router/auto'

// 👉 Redirects - '/' 리다이렉트는 아래 routes에서 정의, 그 외 리다이렉트는 guards.ts에서 처리
export const redirects: RouteRecordRaw[] = []

export const routes: RouteRecordRaw[] = [
  // 루트 경로 리다이렉트
  {
    path: '/',
    name: 'root',
    redirect: '/regle/dashboard',
  },
]
